import { useNavigate } from 'react-router-dom';
import { Color } from '../../assets/color';

const RouteHeader = ({ title, sub_title, url_name, url }) => {
    const navigate = useNavigate();

    return (
        <>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', padding: "20px 5px 40px 5px", }}>
                <div style={{ display: "flex", flexDirection: 'column', gap: "2px" }}>
                    <h3 style={{ fontSize: "30px", fontWeight: '600', textTransform: 'capitalize', background: "linear-gradient(to right, #6653E8, #9544EB)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", display: "inline-block" }}>{title}</h3>
                    <p style={{ color: '#72727B' }}>{sub_title}</p>
                </div>

                {url && url_name && <div onClick={() => navigate(url)} style={{ fontSize: '14.5px', fontWeight: '500', padding: '10px 20px 9px 20px', borderRadius: '20px', background: "linear-gradient(to right,  #6653E8, #9544EB)", color: "#FFF", cursor: 'pointer' }}>{url_name}</div>}
            </div>
        </>
    )
}

export default RouteHeader;